import { Skeleton } from "@/components/ui/skeleton";

const GreetingSkeleton = () => (
  <div className="py-2">
    <Skeleton className="h-7 w-60 mb-2" />
    <Skeleton className="h-4 w-80" delay={60} />
  </div>
);

export default GreetingSkeleton;
